exports.default = {
  'terms_title': '服务条款',
  'privacy_title': '隐私政策',
  'back': '返回',
  'back_home': '返回首页',
  'document_navigation': '法律文档',
  'start_using': '开始使用'
}
